module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/highExposureIcon.7bb3c35d.svg";